import { Button, DatePicker, Input, Popover, Select, Space, Switch, TimePicker } from 'antd'
import React, { useEffect, useState } from 'react'
import { View } from '../../../../styles/reactnative'
import TableAPI from '../../../components/TableAPI'

import { CloseOutlined, FileSearchOutlined } from '@ant-design/icons'
import SettingGroup from 'app/adminpages/AdminSystem/SettingGroup'
import dayjs from 'dayjs'
import moment from 'moment'
import { column_balance_daily } from '../../../components/AdminUserModal/UserInfoTabs/column_balance_daily'
import { ENDTIME, STARTTIME } from '../../../constants/APIKEYS'
import { useWindowDimensions } from '../../../hooks'
import { useUserGroup } from '../../../hooks/user/usergroups'
import { useUserList } from '../../../hooks/user/userlist'

const BalanceMargin = ({ title }) => {
	const now = moment()

	//now 변경
	//다음날 06:59 까지는 전날로 계산
	if (now.hour() < 7) now.subtract(1, 'day')

	const params = new URLSearchParams(window.location.search)
	const idquery = params.get('userid')

	const [search, setSearch] = useState('')
	const [startDate, setStartDate] = useState<any>(
		idquery ? '' : now.format('YYYY-MM-DD')
	)
	const [endDate, setEndDate] = useState<any>(
		idquery ? '' : now.format('YYYY-MM-DD')
	)

	const [startTime, setStartTime] = useState<any>(STARTTIME)
	const [endTime, setEndTime] = useState<any>(ENDTIME)

	const [exceptType1, setExceptType1] = useState(true)
	const [exceptType2, setExceptType2] = useState(true)
	const [exceptType3, setExceptType3] = useState(true)
	const [exceptType4, setExceptType4] = useState(true)
	const [exceptType5, setExceptType5] = useState(true)

	const [old, setOld] = useState(false)

	const [group, setGroup] = useState<string[]>(['*'])
	const { type1 } = useUserGroup()

	const { height } = useWindowDimensions()

	useEffect(() => {
		let exceptType = ''
		if (exceptType1) exceptType += `${exceptType ? ',' : ''}-2`
		if (exceptType2) exceptType += `${exceptType ? ',' : ''}-1`
		if (exceptType3) exceptType += `${exceptType ? ',' : ''}-9`
		if (exceptType4) exceptType += `${exceptType ? ',' : ''}6, -10`
		if (exceptType5) exceptType += `${exceptType ? ',' : ''}7`
		setExceptType(exceptType)
	}, [exceptType1, exceptType2, exceptType3, exceptType4, exceptType5])

	const [exceptType, setExceptType] = useState('')
	const [userId, setUserId] = useState<any>(idquery)
	const [isAll, setIsAll] = useState(false)
	const order = ' daydate asc, id asc '

	//startdate, enddate, excepttype, userid, isall, type, order, searchWord, maxData, page
	console.log(startDate, endDate)

	const url = `/admin/dailybalance?t=
		${(startDate && `&startdate=${startDate}`) || ''}
		${(endDate && `&enddate=${endDate}`) || ''}
		${(exceptType && `&excepttype=${exceptType}`) || ''}
		${(startTime && `&starttime=${startTime}`) || ''}
		${(endTime && `&endtime=${endTime}`) || ''}
		${(userId && `&userid=${userId}`) || ''}
		${(isAll && `&isall=${isAll}`) || ''}
		${(order && `&order=${order}`) || ''}
		${(search && `&searchWord=${search}`) || ''}
		${(group && group.length > 0 && `&group=${group.join(',')}`) || ''}
		${old ? '&old=1' : ''}
	`

	const { usertype1 } = useUserList()
	return (
		<View style={{ width: '100%' }}>
			<Space
				direction="vertical"
				style={{
					width: '100%',
					padding: 10,
					background: '#fff',
					marginTop: 5,
					marginBottom: 5,
					borderRadius: 10,
					flex: 1,
					justifyContent: 'space-between',
					alignItems: 'flex-start',
				}}>
				<View style={{ flexDirection: 'row' }}>
					<Space>
						<Space.Compact direction="horizontal">
							<SettingGroup
								group={group}
								setGroup={setGroup}
								defaultv='*'
								style={{ border: 'none', padding: 0, height: 'auto' }}
							/>
							<Popover
								trigger={'click'}
								content={
									<Space style={{ alignItems: 'center' }}>
										<Select
											defaultValue={''}
											style={{
												width: '100%',
												minWidth: 200,
											}}
											onChange={e => {
												setUserId(e)
											}}
											options={[
												{ value: '', label: '전체' },
												...(usertype1 || []),
											]}
										/>
									</Space>
								}>
								<Input
									placeholder="회원코드"
									value={userId}
									onChange={e => {
										setUserId(e.target.value)
									}}
								/>
							</Popover>
							<Button
								onClick={() => {
									setUserId('')
								}}
								style={{ paddingTop: 0 }}
								size="small">
								{userId ? (
									<CloseOutlined />
								) : (
									<FileSearchOutlined />
								)}
							</Button>
						</Space.Compact>
						<Space.Compact direction="horizontal">
							<Input
								placeholder="검색"
								value={search}
								onChange={e => {
									setSearch(e.target.value)
								}}
							/>
							<Button
								onClick={() => {
									setSearch('')
								}}
								style={{ paddingTop: 0 }}
								size="small">
								{search ? (
									<CloseOutlined />
								) : (
									<FileSearchOutlined />
								)}
							</Button>
						</Space.Compact>
					</Space>
					<Space size="small">
						제외
						<Space
							style={{
								border: '1px solid #ccc',
								padding: 5,
								borderRadius: 5,
							}}>
							<Space.Compact
								size="small"
								style={{ alignItems: 'center' }}>
								거절
								<Switch
									size="small"
									onChange={e => setExceptType1(e)}
									defaultChecked={exceptType1}
								/>
							</Space.Compact>
							<Space.Compact
								size="small"
								style={{ alignItems: 'center' }}>
								대기
								<Switch
									size="small"
									onChange={e => setExceptType2(e)}
									defaultChecked={exceptType2}
								/>
							</Space.Compact>
							<Space.Compact
								size="small"
								style={{ alignItems: 'center' }}>
								블랙
								<Switch
									size="small"
									onChange={e => setExceptType3(e)}
									defaultChecked={exceptType3}
								/>
							</Space.Compact>
							<Space.Compact
								size="small"
								style={{ alignItems: 'center' }}>
								모의
								<Switch
									size="small"
									onChange={e => setExceptType4(e)}
									defaultChecked={exceptType4}
								/>
							</Space.Compact>
							<Space.Compact
								size="small"
								style={{
									alignItems: 'center',
									whiteSpace: 'nowrap',
									fontSize: 10,
								}}>
								페이크
								<Switch
									size="small"
									onChange={e => setExceptType5(e)}
									defaultChecked={exceptType5}
								/>
							</Space.Compact>
						</Space>
					</Space>
					<Space.Compact
						size="small"
						style={{
							alignItems: 'center',
							whiteSpace: 'nowrap',
							fontSize: 10,
						}}>
						전체회원
						<Switch
							onChange={e => setIsAll(e)}
							defaultChecked={isAll}
						/>
					</Space.Compact>
					<Space.Compact
						size="small"
						style={{
							alignItems: 'center',
							whiteSpace: 'nowrap',
							fontSize: 10,
						}}>
						구버전
						<Switch
							onChange={e => setOld(e)}
							defaultChecked={old}
						/>
					</Space.Compact>
				</View>

				<Space>
					기간
					<Space.Compact
						style={{
							alignItems: 'center',
							whiteSpace: 'nowrap',
							fontSize: 10,
						}}>
						<DatePicker
							onChange={e =>
								setStartDate(
									dayjs(e, 'YYYY-MM-DD').format('YYYY-MM-DD')
								)
							}
							defaultValue={
								startDate
									? dayjs(startDate, 'YYYY-MM-DD')
									: undefined
							}
						/>
						<DatePicker
							onChange={e =>
								setEndDate(
									dayjs(e, 'YYYY-MM-DD').format('YYYY-MM-DD')
								)
							}
							defaultValue={
								endDate
									? dayjs(endDate, 'YYYY-MM-DD')
									: undefined
							}
						/>	- 정산시간
						<TimePicker
							onChange={e =>
								setStartTime(
									dayjs(e, 'HH:mm:ss').format('HH:mm:ss')
								)
							}
							defaultValue={
								startTime
									? dayjs(startTime, 'HH:mm:ss')
									: undefined
							}
						/>
						<TimePicker
							onChange={e =>
								setEndTime(
									dayjs(e, 'HH:mm:ss').format('HH:mm:ss')
								)
							}
							defaultValue={
								endTime ? dayjs(endTime, 'HH:mm:ss') : undefined
							}
						/>
					</Space.Compact>
				</Space>
			</Space>

			<TableAPI
				title={title}
				defaultMaxData={100}
				prevsplit={true}
				columns={column_balance_daily}
				usermodal={true}
				height={'default'}
				apikey={url + '&t='}
				footer={1}
			/>
		</View>
	)
}

export default BalanceMargin
